module.exports = __webpack_public_path__ + "media/images/authentication/reset_password-f3bd6d2903fb758ecd5f1c8d2fb5838a.png";